import {updateUsage} from '../../app/modules/auth/core/_requests'
import axios from 'axios'
import {useAuth} from '../../app/modules/auth'

interface IUseRelevanceRequestProps {
  setCurrentAnswer: Function
  requiredQuestions: [] | any
  additionalQuestions: [] | any
  axiosURL: string
  easyRequest: boolean
  inputs: any
  setError: Function
  myRef: React.RefObject<HTMLFormElement>
  setIsLoading?: Function
}

interface IUseRelevanceRequestResult {
  handleForm: (e: React.FormEvent | any) => void
}

const useRelevanceBulkRequest = ({
  myRef,
  setCurrentAnswer,
  requiredQuestions,
  additionalQuestions,
  axiosURL,
  easyRequest,
  inputs,
  setError,
  setIsLoading = () => {},
}: IUseRelevanceRequestProps): IUseRelevanceRequestResult => {
  const RELEVANCE_SECRET = process.env.REACT_APP_RELEVANCE_SECRET
  const {auth} = useAuth()

  const easyRequestCase = (res: any) => {
    updateUsage({words: res.data.output.count_words, credits: res.data.cost})
    const answer =
      res.data.output?.answer === null || res.data.status === 'failed'
        ? 'Oops!.. Incorrect data was passed!.. Try again!'
        : res.data.output.answer
    setIsLoading(false)
    return setCurrentAnswer(answer)
  }

  const hardRequestCase = (response: any) => {
    const pollInterval = setInterval(() => {
      axios
        .get(
          `https://api-d7b62b.stack.tryrelevance.com/latest/studios/${response.data.studio_id}/async_poll/${response.data.job_id}?ending_update_only=true&project=${response.data.project}`,
          {headers: {Authorization: `:${RELEVANCE_SECRET}`}}
        )
        .then((res) => {
          if (res.data.type === 'complete') {
            const answer = res.data.updates[0].output.output.answer
            setCurrentAnswer(answer)
            setIsLoading(false)
            updateUsage({
              words: res.data.updates[0].output.output.count_words,
              credits: res.data.updates[0].output.cost,
            })
            clearInterval(pollInterval)
          }
          if (res.data.type === 'failed') {
            clearInterval(pollInterval)
            setCurrentAnswer(`The unknown error was occuried, please try again!`)
            setIsLoading(false)
          }
        })
        .catch((err) => {
          setCurrentAnswer(`The unknown error was occuried, please try again!`)
          clearInterval(pollInterval)
          setIsLoading(false)
        })
    }, 5000)
  }

  const handleForm = (e: React.FormEvent | any) => {
    e?.type === 'submit' && e.preventDefault()
    const form = myRef.current
    if (form && form.checkValidity()) {
      setIsLoading(true)
      axios
        .post(
          `https://api-d7b62b.stack.tryrelevance.com/latest/studios/${axiosURL}/trigger_limited${
            easyRequest ? '' : '_async'
          }`,
          {
            params: {
              [requiredQuestions[0].axiosParamName]: inputs.requiredQuestion1,
              [requiredQuestions[1]?.axiosParamName]: inputs.requiredQuestion2,
              [requiredQuestions[2]?.axiosParamName]: inputs.requiredQuestion3,
              [requiredQuestions[3]?.axiosParamName]: inputs.requiredQuestion4,
              [requiredQuestions[4]?.axiosParamName]: inputs.requiredQuestion5,

              [additionalQuestions[0]?.axiosParamName]: inputs.additionalQuestion1,
              [additionalQuestions[1]?.axiosParamName]: inputs.additionalQuestion2,
              [additionalQuestions[2]?.axiosParamName]: inputs.additionalQuestion3,

              keywords: inputs.additionalQuestion1.split(' '),
              output_language: inputs.language,
              // linkedin_url: inputs.linkedin_url,
            },

            project: '77b8772bd1a0-4c2f-849c-c4ef9c01c40b',
          },
          {
            headers: {
              Authorization: '',
            },
          }
        )
        .then((response) => {
          easyRequest ? easyRequestCase(response) : hardRequestCase(response)
        })
        .catch((err) => {
          setCurrentAnswer(
            `Oops!.. ${err.response.data.message ? err.response.data.message : 'An error occured'}`
          )
          console.error('An error occured ', err)
        })
        .catch((err) => {
          setCurrentAnswer(
            `Oops!.. ${err.response.data.message ? err.response.data.message : 'An error occured'}`
          )
          if (err.response.status) {
            setError(err.response.data.message || 'Some troubles happened to Internet connection')
            setCurrentAnswer(err.response.data.message, 'upgrade your subscription please')
          }
          setIsLoading(false)
        })

      // setResults(['Some results of request will be here...'])
    }
  }

  return {handleForm}
}

export default useRelevanceBulkRequest
